import { Col, Form, Select } from 'antd'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'

export default function EnumMultiFormField({ fieldInfo }: TFieldProps) {
  const fieldOptions =
    fieldInfo.options?.map((item) => ({ label: `${item}`, value: item })) ?? []

  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`enum-multi-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <Select
          size='small'
          options={fieldOptions}
          mode='multiple'
          allowClear
          filterOption={(input, option) =>
            !!option &&
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        />
      </Form.Item>
    </Col>
  )
}
